import React, { useCallback, useMemo } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import styled from 'styled-components';

import Drawer from '@ecp/common/src/components/modal/mo/Drawer';
import { SITE_SKYPASS } from '@ecp/common/src/const/site/siteNumberConst.js';

import { employeeBenefitOpenState, showNavigationMenuState } from '@mo-recoil/common/navigation/atom';
import { useSiteComponentResolver } from '@mo-hooks/resolver/SiteComponentResolverHook';
import useSiteInfo from '@mo-hooks/common/useSiteInfo';
import NavigationMenu from '@mo-components/common/navigation/NavigationMenu';
import SideFloatingNavigation from '@mo-components/common/navigation/SideFloatingNavigation';
import EmployeeBenefit from '@mo-components/benefit/EmployeeBenefit';
import SkypassNavigationMenu from '@ecp/mo/sites/skypass/components/navigation/SkypassNavigationMenu';

const Container = styled.div`
  position: fixed;
  height: 65px;
  bottom: 0;
  z-index: 100;
  width: ${({ containerWidth }) => containerWidth};
`;

const Navigation = () => {
  const { siteNumber } = useSiteInfo();
  const showNavigationMenu = useRecoilValue(showNavigationMenuState);
  const [employeeBenefitOpen, setEmployeeBenefitOpen] = useRecoilState(employeeBenefitOpenState);

  const handleClose = useCallback(() => {
    setEmployeeBenefitOpen(false);
  }, [setEmployeeBenefitOpen]);

  const ResolvedNavigationMenu = useSiteComponentResolver(<NavigationMenu />, {
    // 대한항공
    [SITE_SKYPASS]: <SkypassNavigationMenu />,
  });

  const containerWidth = useMemo(() => {
    switch (siteNumber) {
      case SITE_SKYPASS:
        return '100%';

      default:
        return '360px';
    }
  }, [siteNumber]);

  return (
    <Container containerWidth={containerWidth}>
      {showNavigationMenu && ResolvedNavigationMenu}
      <SideFloatingNavigation />
      <Drawer
        placement={'right'}
        closePosition={'left'}
        open={employeeBenefitOpen}
        onClose={handleClose}
        value={<EmployeeBenefit onClose={handleClose} />}
      />
    </Container>
  );
};

export default Navigation;
